const CATALOGUE_TITLES = [
  "SG Office Supplies",
  "Daler-Rowney",
  "Major Brushes",
  "Cicada Art & Craft",
  "EYR",
  "Commotion 1",
  "Commotion 2",
  "Cicada Educational 1",
  "Cicada Educational 2",
  "Bishop Sports",
  "Cicada Sensory",
  "Junior Learning",
  "ED-Tech",
  "Furniture",
  "Gift",
  "Step 2",
  "Plumplay",
  "Learning Resources",
  "Show Me",
  "Viga",
  "PolarB",
  "EduScience Chemistry",
  "EduScience Physics",
  "EduScience Biology",
  "EDX",
  "Playlearn Sensory",
];

export const CATALOGUE_FALLBACKS = {
  hero: {
    title: "Catalogue",
    subtitle: "Browse & Download",
    description:
      "Explore our product catalogues and download the latest PDF brochures for office, school, art, and educational supplies.",
  },
  items: CATALOGUE_TITLES.map((title, index) => ({
    title,
    image: "",
    fileUrl: "",
    buttonText: "View & Download Here",
    sortOrder: index,
    isActive: true,
  })),
};

export function mergeCatalogueContent(apiContent) {
  if (!apiContent) return CATALOGUE_FALLBACKS;

  const hero = {
    ...CATALOGUE_FALLBACKS.hero,
    ...(apiContent.hero || {}),
  };

  let items = Array.isArray(apiContent.items) ? apiContent.items : [];
  if (!items.length) {
    items = CATALOGUE_FALLBACKS.items;
  } else {
    items = items
      .filter((item) => item.isActive !== false)
      .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
      .map((item) => ({
        ...item,
        buttonText: item.buttonText || "View & Download Here",
      }));
  }

  return { hero, items };
}
